import Button from 'components/Button';
import { Row } from 'components/Layout';
import Chip from 'components/Chip';
import { pluralizedCount } from 'further-ui/utils';
import { AppSimpleSelect } from 'components/FormElements';
import { AmlResultsArchiveStatus } from 'further-types/kyc';
import { Grid, styled } from '@mui/material';

type Props = {
  potentialMatches: number;
  potentialUnarchivedMatches: number;
  potentialArchivedMatches: number;
  showAmlResults: boolean;
  toggleAmlResults: () => void;
  amlHasUpdates: boolean;
  handleAmlResultsStatusFilterChange: (value: AmlResultsArchiveStatus) => void;
  amlResultsStatusFilter: AmlResultsArchiveStatus;
};

const StyledAppSimpleSelect = styled(AppSimpleSelect)({
  minWidth: '150px',
});

const Label = styled(Grid)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const StyledFixedHeightRow = styled(Row)(() => ({
  height: '21px',
}));

const AmlResults: React.FC<Props> = ({
  potentialMatches,
  potentialUnarchivedMatches,
  potentialArchivedMatches,
  showAmlResults,
  toggleAmlResults,
  amlHasUpdates,
  handleAmlResultsStatusFilterChange,
  amlResultsStatusFilter,
}) => {
  return (
    <Row centered spacing="sm" fullWidth justify="space-between">
      <Row centered spacing="sm">
        <span>
          {potentialUnarchivedMatches === 0
            ? `No potential matches${
                potentialArchivedMatches > 0
                  ? `. ${pluralizedCount(
                      'hit',
                      potentialArchivedMatches,
                      'hits',
                    )} archived.`
                  : ''
              }`
            : pluralizedCount(
                'potential match',
                potentialUnarchivedMatches,
                'potential matches',
              )}
        </span>

        {potentialMatches !== 0 && (
          <Button
            size="extra-small"
            variant="outlined"
            color="primary"
            onClick={toggleAmlResults}
          >
            {showAmlResults ? 'Hide results' : 'Show results'}
          </Button>
        )}

        {amlHasUpdates && potentialMatches > 0 && (
          <Chip variant="disabled"> Updated </Chip>
        )}
      </Row>

      {showAmlResults && (
        <StyledFixedHeightRow centered spacing="sm">
          <Label>Status:</Label>
          <StyledAppSimpleSelect
            options={[
              {
                label: 'Not archived',
                value: AmlResultsArchiveStatus.NotArchived,
              },
              {
                label: 'Archived',
                value: AmlResultsArchiveStatus.Archived,
              },
              {
                label: 'Show all',
                value: AmlResultsArchiveStatus.All,
              },
            ]}
            value={amlResultsStatusFilter ?? ''}
            placeholder="Select archive status"
            onChange={(e) => {
              handleAmlResultsStatusFilterChange(
                e.target.value as AmlResultsArchiveStatus,
              );
            }}
          />
        </StyledFixedHeightRow>
      )}
    </Row>
  );
};

export default AmlResults;
